export default {
  ACTUAL_OVER_360: "ACTUAL_OVER_360",
  THIRTY_OVER_360: "THIRTY_OVER_360",
  ACTUAL_OVER_365: "ACTUAL_OVER_365"
};
